import axios from "axios";
import { useState } from "react";
import { url } from '../utils/config';
import QRCode from "react-qr-code";
import Input from "../reusable_components/Input";
import { toast } from "react-toastify";
import validateImageDimension from "../custom_functions/validateImageDimension";
import { btnCancel, btnOne, inputStyle, label, modalContainer, modalTitle } from "../utils/style";
import Button from "../reusable_components/Button";

function AddGeneralEquipmentItem(props) {
    const [ formType, setFormType ] = useState('Add');
    const [ formData, setFormData ] = useState({});
    const [ image, setImage ] = useState();
    const [ imageUrl, setImageUrl ] = useState();
    const [ equipmentIndex, setEquipmentIndex ] = useState(props.equipments.length !== 0 ? 0 : null);
    const [ newQuantity, setNewQuantity ] = useState(null);
    const [ showQr, setShowQr ] = useState(null);
    const [ missingFields, setMissingFields ] = useState([]);
    const [ inputErrors, setInputErrors ] = useState([]);
    const [ showInputError, setShowInputError ] = useState(false);
console.log(props)
    
    function updateFormData(e) {
        const { name, value } = e.target;
        const data = {...formData};
        data[name] = value;
        setFormData(data);
    }


    function addEquipment(e) {
        const reqUrl = url + '/general_equipment_item';
        const token = window.localStorage.getItem('token');
        const headers = { authorization: `bearer ${token}` };
        const formdata = new FormData();
        console.log(equipmentIndex)
        const itemNumber = props.equipments.equipmentLists.filter(eq => eq.general_equipment_id === props.equipments.specialEquipments[parseInt(equipmentIndex)].id).length;
        formdata.append('serialNumber', formData.serialNumber);
        formdata.append('itemNumber', itemNumber)

        if(image) {
            formdata.append('image', image);
        }

        if(formData.equipmentName) {
            formdata.append('equipmentName', formData.equipmentName)
        } else {
            formdata.append('general_equipment_id', props.equipments.specialEquipments[parseInt(equipmentIndex)].id)
        }

        
        axios.post(reqUrl, formdata, { headers })
        .then(res => {
            setShowQr(JSON.stringify(res.data.data))
            props.reload(1 + Math.random())
        })
        .catch(err => toast.error(err.response.data.message, { autoClose: 3000 }))
        // props.setShowAddForm(false)
    }

    function modifyEquipment(e) {
        e.preventDefault();
        const reqUrl = url + '/modify_special_equipment';
        const token = window.localStorage.getItem('token');
        const headers = { authorization: `bearer ${token}` };
        const data = {
            quantity: newQuantity,
            id: props.equipments[equipmentIndex]['id']
        }
        axios.post(reqUrl, data, { headers })
        .then(res => console.log(res.data))
        .catch(err => console.log(err))
        props.setShowAddForm(false)
    }

    function addImage(e){
        const file = e.target.files[0];
        validateImageDimension(
            file, 
            () => {
                toast.error('Image dimension should be between 256x256 and 720x720!', { autoClose: 3000 })
            },
            () => {
                setImage(file);
                setImageUrl(URL.createObjectURL(file));
            }
        );
    }

    return(
        <div className={modalContainer}>
            <div className="px-4 flex justify-center flex-col  w-1/2">

                {
                showQr ? 
                <div className="flex flex-col gap-4 items-center justify-center">
                    <QRCode value={showQr} />
                    <span>
                        <button onClick={() => props.setShowAddForm(false)} className={btnOne}>Close</button>
                    </span>
                </div>
                :
                <div>
                    {/* <div className="flex"> */}
                        {/* <button onClick={() => setFormType('Add')} className={`${formType === 'Add' ? 'text-white bg-gray-500' :'bg-white'} font-semibold border border-black flex justify-center items-center py-2 px-10 rounded-md cursor-pointer font-family-audiowide mr-4`}>ADD</button> */}
                        {/* <button onClick={() => setFormType('Modify')} className={`${formType === 'Modify' ? 'text-white bg-gray-500' :'bg-white'} font-semibold border border-black flex justify-center items-center py-2 px-10 rounded-md cursor-pointer font-family-audiowide`}>MODIFY</button> */}
                    {/* </div> */}
                    <div className="rounded-lg bg-white w-full p-8">
                        <div className={modalTitle}>Add Equipment</div>
                        <div className="grid grid-cols-3 py-2 px-2">
                            <label className={label}>Equipment Name</label>
                            <div className="col-span-2">
                                {
                                    equipmentIndex !== 'custom' ?
                                    <select 
                                        name="id" 
                                        className={inputStyle} 
                                        placeHolder="Equipment" 
                                        onChange={e => setEquipmentIndex(e.target.value)}
                                    >
                                        {
                                        props?.equipments?.specialEquipments?.map((eq, ind) => <option key={ind} value={ind} >{eq.name}</option>)
                                        }
                                    </select>
                                    :
                                    <input name="equipmentName" type='text' className={inputStyle} placeholder="Enter Equipment Name" onChange={e => updateFormData(e)}/>
                                }
                            </div>
                        </div>
                        <div className="grid grid-cols-3 py-2 px-2">
                            <label className={label}>Serial Number</label>
                            <div className="col-span-2">
                                {
                                    formType === 'Add' ? 
                                    <Input 
                                        index={1}
                                        inputErrors={inputErrors}
                                        setInputErrors={setInputErrors}
                                        missingFields={missingFields}
                                        required={true}
                                        name="serialNumber" 
                                        value={formData.serialNumber}
                                        className={inputStyle}
                                        placeHolder="Enter Serial Number" 
                                        onChange={e => updateFormData(e)}
                                    />
                                    :
                                    <select name="serialNumber" className={inputStyle}>
                                        {
                                            props?.equipments?.equipmentList?.filter(eq => eq.id === props.specialEquipments[equipmentIndex]['id']).map((eq, ind) => <option key={ind} value={eq.serialNumber} >{eq.serialNumber}</option>)
                                        }
                                    </select>
                                }
                            </div>
                        </div>
                        {/* {
                            formType === 'Modify' ?    
                            <div className="grid grid-cols-3 py-2 px-2">
                                <label className="col-span-1 h-8 flex text-lg ">New Quantity</label>
                                <input type='number' value={newQuantity} className="col-span-2 h-8 outline-none border border-gray-400 rounded-lg text-gray-500 text-lg px-3 -light" placeholder="Enter New Quantity" onChange={e => setNewQuantity(e.target.value)}/>
                            </div> : null
                        } */}
                        {
                            formType === 'Add' && equipmentIndex === 'custom' ? 
                                (
                                    !image ? 
                                    <>
                                        <div className="grid grid-cols-3 py-2 px-2">
                                            <label htmlFor="img-upld" className="col-span-3 cursor-pointer mx-20 h-8 flex text-lg  border-2 rounded-md justify-center border-gray-500"><b className="mr-2">+</b>Add Image for New Equipment</label>
                                            <input name="image" type='file' id="img-upld" className="hidden" onChange={e => addImage(e)}/>
                                        </div>
                                    </> :
                                    <div className="flex justify-center">
                                        <div><img src={imageUrl} /></div>
                                        <div>{image.name}</div>
                                    </div>
                                ) : null
                        }
                        <div className="flex justify-between py-3 px-16 gap-8">
                            <button onClick={() => props.setShowAddForm(false)} className={btnCancel}>Cancel</button>
                            <Button clickHandler={() => addEquipment()} className={btnOne} name={'Submit'} />
                        </div>
                        <div className="text-red-500 font-semibold text-center">
                            {
                                showInputError && 'Please fill all the fields as directed!'
                            }
                        </div>
                    </div>
                </div>
            }
            )
            </div>
        </div>
    )
}

export default AddGeneralEquipmentItem;